//--------------------Edit Provider Profile Start -----------------//
 
// Edit Provider Profile  Action Types
export const FETCH_EDITRAD_PROFILE_REQUEST = 'FETCH_EDITRAD_PROFILE_REQUEST';
export const FETCH_EDITRAD_PROFILE_SUCCESS = 'FETCH_EDITRAD_PROFILE_SUCCESS';
export const FETCH_EDITRAD_PROFILE_FAILURE = 'FETCH_EDITRAD_PROFILE_FAILURE';
 
// Save Provider Profile Action Types
export const SAVE_RAD_REQUEST = 'SAVE_RAD_REQUEST';
export const SAVE_RAD_SUCCESS = 'SAVE_RAD_SUCCESS';
export const SAVE_RAD_FAILURE = 'SAVE_RAD_FAILURE';
 
// Get City State by ZipCode Action Types
export const GET_CITY_STATE_BY_ZIPCODE_REQUEST = 'GET_CITY_STATE_BY_ZIPCODE_REQUEST';
export const GET_CITY_STATE_BY_ZIPCODE_SUCCESS = 'GET_CITY_STATE_BY_ZIPCODE_SUCCESS';
export const GET_CITY_STATE_BY_ZIPCODE_FAILURE = 'GET_CITY_STATE_BY_ZIPCODE_FAILURE';
 
// Save Radiologist Note Action Types
export const SAVE_RAD_NOTE_REQUEST = 'SAVE_RAD_NOTE_REQUEST';
export const SAVE_RAD_NOTE_SUCCESS = 'SAVE_RAD_NOTE_SUCCESS';
export const SAVE_RAD_NOTE_FAILURE = 'SAVE_RAD_NOTE_FAILURE';

// Save Radiologist Tags Action Types
export const SAVE_RAD_TAGS_REQUEST = 'SAVE_RAD_TAGS_REQUEST';
export const SAVE_RAD_TAGS_SUCCESS = 'SAVE_RAD_TAGS_SUCCESS';
export const SAVE_RAD_TAGS_FAILURE = 'SAVE_RAD_TAGS_FAILURE';
 
// Fetch Week Rotation Template by ID Action Types
export const FETCH_WEEK_ROTATION_TEMPLATE_BY_ID_REQUEST_RADPROFILE = 'FETCH_WEEK_ROTATION_TEMPLATE_BY_ID_REQUEST_RADPROFILE';
export const FETCH_WEEK_ROTATION_TEMPLATE_BY_ID_SUCCESS_RADPROFILE = 'FETCH_WEEK_ROTATION_TEMPLATE_BY_ID_SUCCESS_RADPROFILE';
export const FETCH_WEEK_ROTATION_TEMPLATE_BY_ID_FAILURE_RADPROFILE = 'FETCH_WEEK_ROTATION_TEMPLATE_BY_ID_FAILURE_RADPROFILE';
export const CLEAR_WEEK_ROTATION_TEMPLATE_DATA_RADPROFILE = 'CLEAR_WEEK_ROTATION_TEMPLATE_DATA_RADPROFILE';
 
// Save Schedule Week Rotation Action Types
export const SAVE_SCHEDULE_WEEK_ROTATION_REQUEST = 'SAVE_SCHEDULE_WEEK_ROTATION_REQUEST';
export const SAVE_SCHEDULE_WEEK_ROTATION_SUCCESS = 'SAVE_SCHEDULE_WEEK_ROTATION_SUCCESS';
export const SAVE_SCHEDULE_WEEK_ROTATION_FAILURE = 'SAVE_SCHEDULE_WEEK_ROTATION_FAILURE';

// Rate Card Action Types
export const GET_RATE_CARD_DETAILS_BY_RAD_ID_REQUEST = 'GET_RATE_CARD_DETAILS_BY_RAD_ID_REQUEST';
export const GET_RATE_CARD_DETAILS_BY_RAD_ID_SUCCESS = 'GET_RATE_CARD_DETAILS_BY_RAD_ID_SUCCESS';
export const GET_RATE_CARD_DETAILS_BY_RAD_ID_FAILURE = 'GET_RATE_CARD_DETAILS_BY_RAD_ID_FAILURE';

// Get Provider Contract Information
export const FETCH_EDITRAD_PROFILE_CONTRACT_SUMMARY_REQUEST = 'FETCH_RAD_CONTRACT_SUMMARY_REQUEST';
export const FETCH_EDITRAD_PROFILE_CONTRACT_SUMMARY_SUCCESS = 'FETCH_RAD_CONTRACT_SUMMARY_SUCCESS';
export const FETCH_EDITRAD_PROFILE_CONTRACT_SUMMARY_FAILURE = 'FETCH_RAD_CONTRACT_SUMMARY_FAILURE';

// Get Provider Contract Documents
export const FETCH_EDITRAD_PROFILE_CONTRACT_DOCUMENTS_REQUEST = 'FETCH_RAD_CONTRACT_DOCUMENTS_REQUEST';
export const FETCH_EDITRAD_PROFILE_CONTRACT_DOCUMENTS_SUCCESS = 'FETCH_RAD_CONTRACT_DOCUMENTS_SUCCESS';
export const FETCH_EDITRAD_PROFILE_CONTRACT_DOCUMENTS_FAILURE = 'FETCH_RAD_CONTRACT_DOCUMENTS_FAILURE';

// Provider Assignments Action Types
export const FETCH_RAD_ASSIGNMENTS_DROPDOWN_REQUEST = 'FETCH_RAD_ASSIGNMENTS_DROPDOWN_REQUEST';
export const FETCH_RAD_ASSIGNMENTS_DROPDOWN_SUCCESS = 'FETCH_RAD_ASSIGNMENTS_DROPDOWN_SUCCESS';
export const FETCH_RAD_ASSIGNMENTS_DROPDOWN_FAILURE = 'FETCH_RAD_ASSIGNMENTS_DROPDOWN_FAILURE';

export const FETCH_RAD_ASSIGNMENTS_DETAILS_REQUEST = 'FETCH_RAD_ASSIGNMENTS_DETAILS_REQUEST';
export const FETCH_RAD_ASSIGNMENTS_DETAILS_SUCCESS = 'FETCH_RAD_ASSIGNMENTS_DETAILS_SUCCESS';
export const FETCH_RAD_ASSIGNMENTS_DETAILS_FAILURE = 'FETCH_RAD_ASSIGNMENTS_DETAILS_FAILURE';

export const SAVE_RAD_ASSIGNMENTS_REQUEST = 'SAVE_RAD_ASSIGNMENTS_REQUEST';
export const SAVE_RAD_ASSIGNMENTS_SUCCESS = 'SAVE_RAD_ASSIGNMENTS_SUCCESS';
export const SAVE_RAD_ASSIGNMENTS_FAILURE = 'SAVE_RAD_ASSIGNMENTS_FAILURE';

export const DELETE_RAD_ASSIGNMENT_REQUEST = 'DELETE_RAD_ASSIGNMENT_REQUEST';
export const DELETE_RAD_ASSIGNMENT_SUCCESS = 'DELETE_RAD_ASSIGNMENT_SUCCESS';
export const DELETE_RAD_ASSIGNMENT_FAILURE = 'DELETE_RAD_ASSIGNMENT_FAILURE';
 
// Rad Document Types Dropdown Action Types
export const FETCH_RAD_DOCUMENT_TYPES_REQUEST = 'FETCH_RAD_DOCUMENT_TYPES_REQUEST';
export const FETCH_RAD_DOCUMENT_TYPES_SUCCESS = 'FETCH_RAD_DOCUMENT_TYPES_SUCCESS';
export const FETCH_RAD_DOCUMENT_TYPES_FAILURE = 'FETCH_RAD_DOCUMENT_TYPES_FAILURE';

// Rad Document Management Action Types
export const FETCH_RAD_DOCUMENTS_REQUEST = 'FETCH_RAD_DOCUMENTS_REQUEST';
export const FETCH_RAD_DOCUMENTS_SUCCESS = 'FETCH_RAD_DOCUMENTS_SUCCESS';
export const FETCH_RAD_DOCUMENTS_FAILURE = 'FETCH_RAD_DOCUMENTS_FAILURE';

export const UPLOAD_RAD_DOCUMENT_REQUEST = 'UPLOAD_RAD_DOCUMENT_REQUEST';
export const UPLOAD_RAD_DOCUMENT_SUCCESS = 'UPLOAD_RAD_DOCUMENT_SUCCESS';
export const UPLOAD_RAD_DOCUMENT_FAILURE = 'UPLOAD_RAD_DOCUMENT_FAILURE';

export const DELETE_RAD_DOCUMENT_REQUEST = 'DELETE_RAD_DOCUMENT_REQUEST';
export const DELETE_RAD_DOCUMENT_SUCCESS = 'DELETE_RAD_DOCUMENT_SUCCESS';
export const DELETE_RAD_DOCUMENT_FAILURE = 'DELETE_RAD_DOCUMENT_FAILURE';

export const DOWNLOAD_RAD_DOCUMENT_REQUEST = 'DOWNLOAD_RAD_DOCUMENT_REQUEST';
export const DOWNLOAD_RAD_DOCUMENT_SUCCESS = 'DOWNLOAD_RAD_DOCUMENT_SUCCESS';
export const DOWNLOAD_RAD_DOCUMENT_FAILURE = 'DOWNLOAD_RAD_DOCUMENT_FAILURE';

// Rad Note Types Dropdown Action Types
export const FETCH_RAD_NOTE_TYPES_REQUEST = 'FETCH_RAD_NOTE_TYPES_REQUEST';
export const FETCH_RAD_NOTE_TYPES_SUCCESS = 'FETCH_RAD_NOTE_TYPES_SUCCESS';
export const FETCH_RAD_NOTE_TYPES_FAILURE = 'FETCH_RAD_NOTE_TYPES_FAILURE';

// Active Home State License Dropdown Action Types
export const FETCH_ACTIVE_HOME_STATE_LICENSE_DROPDOWN_REQUEST = 'FETCH_ACTIVE_HOME_STATE_LICENSE_DROPDOWN_REQUEST';
export const FETCH_ACTIVE_HOME_STATE_LICENSE_DROPDOWN_SUCCESS = 'FETCH_ACTIVE_HOME_STATE_LICENSE_DROPDOWN_SUCCESS';
export const FETCH_ACTIVE_HOME_STATE_LICENSE_DROPDOWN_FAILURE = 'FETCH_ACTIVE_HOME_STATE_LICENSE_DROPDOWN_FAILURE';

//--------------------Edit Provider Profile End -----------------//